"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchCallRecipientStatus = void 0;
exports.BatchCallRecipientStatus = {
    Pending: "pending",
    Initiated: "initiated",
    InProgress: "in_progress",
    Completed: "completed",
    Failed: "failed",
    Cancelled: "cancelled",
};
